import * as Sentry from '@sentry/react';

import { history } from '@/shared/components/react-router-dom';

Sentry.init({
  dsn: 'https://55433e6ef5b04babae2f283f0f67f513@o383086.ingest.us.sentry.io/5224690',
  integrations: [Sentry.reactRouterV5BrowserTracingIntegration({ history })],
});
